<script>
	module.exports = {
		props: ['article', 'routeContext'],
		data() {
			return {
				organizerData: null
			};
		},
		components: {
			'word-detective': require('components/word-detective.vue').default
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.word-detective-preview {
	}
</style>
<template>
	<div class="word-detective-preview row margin-bottom-large">
		<div class="large-8 columns padding-top-medium">
			<p>
				Word Detective is a brief, teacher-led activity where students investigate word parts in the context of their Article-A-Day reading. See the
				sidebar to learn more!
			</p>
			<p>Example of Student Workspace:</p>
			<word-detective
				:demo="true"
				:organizer-data.sync="organizerData"
				:product="article"></word-detective>
		</div>
		<div class="large-4 columns print-hidden">
			<article-aside
				v-bind:product="article"
				v-bind:article="article"
				v-bind:search-query-string="routeContext.parsedPath.getQueryParam('search')"></article-aside>
		</div>
	</div>
</template>
